import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface DownloadCSVOptions {
  event: { slug: string; space_id: string | number };
  peopleV4?: boolean;
}

export const downloadEventAttendeesCSV = ({
  event,
  peopleV4 = false,
}: DownloadCSVOptions) =>
  reactQueryGet(
    internalApi.eventAttendees.exportCsv({
      spaceId: event.space_id,
      slug: event.slug,
      params: peopleV4 ? { people_v4: true } : {},
    }),
  );
